import * as React from "react";
import { Page, Font, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";

import { JSONGenerator, imagePathurl } from "../../../utils/utils";

Font.register({
    family: "ITC",
    fonts: [
        {
            src: "../../../../assets/fonts/ITCAvantGardeStd-Bk.ttf",
        },
        {
            src: "../../../../assets/fonts/ITCAvantGardeStd-Bold.ttf",
            fontWeight: "bold",
        },
        {
            src: "../../../../assets/fonts/ITCAvantGardeStd-Demi.ttf",
            fontWeight: "ultrabold",
        },
        {
            src: "../../../../assets/fonts/ITCAvantGardeStd-Md.ttf",
            fontWeight: "medium",
        },
        {
            src: "../../../../assets/fonts/ITCAvantGardeStd-Demi.ttf",
            fontWeight: "semibold",
        },
    ],
});

// Create styles for SummaryPDFDocument
const styles = StyleSheet.create({
    page: {
        padding: "8px 40px 40px 40px",
        backgroundColor: "#f3f3f3",
        fontFamily: "ITC",
    },
    heading: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        fontSize: 22,
        marginTop: 20,
        marginBottom: 20,
        alignItems: "center",
    },
    headerLeft: {
        width: "40%",
        fontWeight: "ultrabold",
    },
    headerRight: {
        width: "60%",
        textAlign: "right",
        fontFamily: "ITC",
        fontWeight: "semibold",
        fontSize: "12px",
    },
    section: {
        padding: 12,
        marginBottom: 14,
        flexGrow: 1,
        backgroundColor: "#FFFFFF",
    },
    sectionHeader: {
        fontFamily: "ITC",
        fontSize: 12,
        paddingBottom: 5,
        fontWeight: "semibold",
        textTransform: "uppercase",
        color: "#666666",
    },
    sectionRow: {
        paddingTop: 10,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        fontSize: "9px",
    },
    sectionRowLabel: {
        width: "32%",
        paddingRight: 10,
        fontWeight: "semibold",
    },
    sectionRowValue: {
        width: "68%",
    },
    warrantyCost: {
        paddingTop: 4,
    },
    cost: {
        color: "#D71920",
    },
});

// Create SummaryPDFDocument Component
const SummaryPDFDocument = ({ reviewData, warrantyId, warrantyNumber }): any => {
    const getimagePath = imagePathurl();
    const data = Object.keys(reviewData).length > 0 ? JSONGenerator(reviewData.residentialWarranty) : {};
    const headers = Object.keys(data).filter((item) => item !== "cost");
    const DocumentSections = headers.map((headerItem, index) => {
        const sectionRows = Object.keys(data[headerItem]).map((sectionRowItem, rowIndex) => {
            let value = null;
            if (Array.isArray(data[headerItem][sectionRowItem])) {
                value = (
                    <View style={styles.sectionRowValue}>
                        {data[headerItem][sectionRowItem].map((item, index) => (
                            <Text key={index}>{item}</Text>
                        ))}
                    </View>
                );
            } else {
                value = <Text style={styles.sectionRowValue}>{data[headerItem][sectionRowItem]}</Text>;
            }
            return (
                <View key={rowIndex} style={styles.sectionRow} wrap={false}>
                    <Text style={styles.sectionRowLabel}>{sectionRowItem}</Text>
                    {value}
                </View>
            );
        });
        return (
            <View key={index} style={styles.section}>
                <Text style={styles.sectionHeader}>{headerItem}</Text>
                {sectionRows}
            </View>
        );
    });
    let cost = "0.00";
    try {
        cost = parseFloat(data["cost"]).toFixed(2);
    } catch (err) {
        cost = data["cost"];
    }
    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.heading} fixed>
                    <View style={styles.headerLeft}>
                        <Image src={`${getimagePath}SteepSlope.png`} />
                    </View>
                    <View style={styles.headerRight}>
                        {/* <Text>Warranty ID #{`${warrantyId}`}</Text> */}
                        <Text>Warranty Number #{`${warrantyNumber}`}</Text>
                        <Text style={styles.warrantyCost}>
                            Total Warranty Cost: <Text style={styles.cost}>{`$${cost}`}</Text>
                        </Text>
                    </View>
                </View>
                {DocumentSections}
            </Page>
        </Document>
    );
};

export default SummaryPDFDocument;
